import { selectCurrentEntity } from '@opengov/app-core/entity';
import { ColumnTypes } from '../../../../src/components/table/columnTypes';
import { calendarUnitFormatters } from '@opengov/reporting-formatters/formatters';
import {
  CalendarUnit,
  EReportColumnTypes,
  IReportConfiguration,
  OrganizedByColumnType
} from '@opengov/reporting-types';
import { createSelector } from 'reselect';
import { getTableColumnTypeFromReportColumnType } from '../../../common/helpers/semanticTypeToColumnType';
import { selectReportExplorerMsgs } from '../../../common/locale';
import { selectSummaryTableData, selectSummaryTableReportConfiguration } from '../../../summaryTable/selectors';

export const getFormatterForTicks = (
  reportConfiguration: IReportConfiguration,
  emptyValuesText: string,
  entityFiscalYearStartMonth: number
) => {
  const organizedBy = reportConfiguration.visualizationQuery.organizedBy;
  let formatter = (domain: string | number) => `${domain || emptyValuesText}`;

  if (
    organizedBy.selection &&
    (organizedBy.columnType === OrganizedByColumnType.Date || organizedBy.selection === CalendarUnit.FiscalPeriod)
  ) {
    const { formatter: dateFormatter } = calendarUnitFormatters[organizedBy.selection];

    let fiscalYearStartMonth = entityFiscalYearStartMonth;

    // FiscalQuarter is already translated in the query
    if (organizedBy.selection === CalendarUnit.FiscalQuarter) {
      fiscalYearStartMonth = 1;
    }

    formatter = dateFormatter({ entityFiscalYearStartMonth: fiscalYearStartMonth });
  }

  return formatter;
};

export const selectSummaryGridColumnDefs = createSelector(
  selectSummaryTableReportConfiguration,
  selectReportExplorerMsgs,
  selectSummaryTableData,
  selectCurrentEntity,
  (reportConfiguration, reportMessages, chartData, entity) => {
    if (!reportConfiguration) return [];

    const isPercentOfTotal =
      reportConfiguration.visualizationQuery.showColumn.columnType === EReportColumnTypes.percentOfTotal;

    const tickFormatter = getFormatterForTicks(
      reportConfiguration,
      reportMessages.emptyValues,
      entity.fiscal_year_start_month
    );

    const columnType = isPercentOfTotal
      ? ColumnTypes.Percent
      : getTableColumnTypeFromReportColumnType(reportConfiguration.visualizationQuery.showColumn);

    return chartData.map((column) => {
      return {
        headerName: tickFormatter(column.name),
        field: `${column.name}`,
        type: columnType,
        isValueColumn: true,
        sortable: true,
        headerClass: 'ag-right-aligned-header',
        cellStyle: { textAlign: 'right' },
        valueGetter: (params) => params.data[params.colDef.field]
      };
    });
  }
);
